import React, { useEffect, useRef, useState } from "react";
import { Modal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import styled from "styled-components";
import { PushSettingType, soundList } from "../../recoil/sound";
import "../../styles/CustomModal.css";
import AsyncLocalStorage from "../../utils/AsyncLocalStorage";
import CustomToggle from "../CustomToggle";
import { getRecoil } from "recoil-nexus";
import {
  authStoreListState,
  authStoreType,
  versionState,
} from "../../recoil/auth";
import StoreController from "../../controller/StoreController";
import { useRecoilValue } from "recoil";
import LogController from "../../controller/LogController";
import toast from "react-hot-toast";

type Props = {
  isVisible: boolean;
  setVisible: (bVisible: boolean) => void;
  pushSetting: PushSettingType;
  setPushSetting: (bSetting: PushSettingType) => void;
};

interface Sound {
  audio: HTMLAudioElement;
}

const PushSettingModal = ({
  isVisible,
  setVisible,
  pushSetting,
  setPushSetting,
}: Props) => {
  // 토글
  // const [autoPushOrder, setAutoPushOrder] = useState<boolean>(
  //   pushSetting.autoPushOrder
  // );

  // 알림 횟수 제한
  const [orderCount, setOrderCount] = useState<number>(1000);
  const [isInfinite, setIsInfinite] = useState<boolean>(true);

  // 알림 음량
  const [volumeItems, setVolumeItems] = useState<number[]>([]);

  const soundsRef = useRef<Sound[]>([]);
  const [selectedEffect, setSelectedEffect] = useState<string>(
    pushSetting.effect
  );
  const [volume, setVolume] = useState<number>(pushSetting.volume);

  const [audioDelay, setAudioDelay] = useState<number>(pushSetting.delay);

  const version = useRecoilValue(versionState);

  const initializeSounds = () => {
    const loadedSounds: Sound[] = soundList.effectSound.map((item: string) => {
      const audio = new Audio(item);
      return { audio };
    });
    soundsRef.current = loadedSounds;
  };

  const onCloseModal = () => {
    setVisible(false);
  };

  const savePushSetting = async () => {
    const pushSetting = {
      effect: selectedEffect,
      volume: volume,
      // autoPushOrder: true,
      orderCount: orderCount,
      infinite: isInfinite,
      delay: audioDelay,
    };
    setPushSetting(pushSetting);
    console.log("pushSetting", pushSetting);
    await AsyncLocalStorage.setItem("pushSetting", JSON.stringify(pushSetting));

    toast.success("변경된 알림설정을 저장했어요");

    LogController.click({
      path: "pushSettingModal",
      params: "알림 설정",
      params2: JSON.stringify(pushSetting),
    });
  };

  const onChange_selectedEffect = (value: string, index: number) => {
    if (version.length === 0) {
      if (soundsRef.current[index] && soundsRef.current[index].audio) {
        soundsRef.current[index].audio.currentTime = 0;
        soundsRef.current[index].audio.volume = volume / 10;
        soundsRef.current[index].audio.play();
      }
    } else {
      window.parent.postMessage(
        JSON.stringify({
          action: "audio",
          data: {
            type: "test",
            audio: value,
            volume: volume,
            count: 1,
            audio_delay: audioDelay,
            play_status: true,
          },
        }),
        "*"
      );
    }
    setSelectedEffect(value);
    // AsyncLocalStorage.setItem("effect", JSON.stringify(value));
  };

  const setInfinity = (value: boolean) => {
    setIsInfinite(value);
    if (value) {
      setOrderCount(1000);
    } else {
      setOrderCount(1);
    }
  };

  const addCount = () => {
    if (orderCount < 10 && !isInfinite) {
      setOrderCount(orderCount + 1);
    }
  };
  const subtractCount = () => {
    if (orderCount === 1) {
      setOrderCount(1);
      return;
    }
    if (orderCount > 0 && !isInfinite) {
      setOrderCount(orderCount - 1);
    }
  };

  const addDelay = () => {
    if (audioDelay < 10) {
      setAudioDelay(audioDelay + 1);
    }
  };
  const subtractDelay = () => {
    if (audioDelay === 1) {
      setAudioDelay(1);
      return;
    }
    setAudioDelay(audioDelay - 1);
  };

  // 알림 음량
  const onChange_volume = (value: number) => {
    if (value > 0 && value < 11) {
      setVolume(value);
      window.parent.postMessage(
        JSON.stringify({
          action: "audio",
          data: {
            type: "test",
            audio: selectedEffect,
            volume: value,
            count: 1,
            audio_delay: audioDelay,
            play_status: true,
          },
        }),
        "*"
      );
    }
  };

  const getVolumeItems = (value: number) => {
    const array = Array(10).fill(0);
    for (let i = 0; i < value; i++) {
      array[i] = 1;
    }
    setVolumeItems(array);
  };

  const getSoundData = () => {
    const settingTemp = AsyncLocalStorage.getItem("pushSetting");

    console.log(
      "~~~~~~~~~~~~~~~~~~~~~~~~getSoundData~~~~~~~~~~~~~~~~~~~~~~~~~~~~",
      settingTemp,
      pushSetting
    );
    if (settingTemp) {
      setPushSetting({ ...settingTemp });

      setSelectedEffect(settingTemp.effect);
      setVolume(settingTemp.volume);
      // setAutoPushOrder(settingTemp.autoPushOrder);
      setOrderCount(settingTemp.orderCount);
      setIsInfinite(settingTemp.orderCount < 11 ? false : true);
      setAudioDelay(settingTemp.delay);

      saveLocalPushSettings(settingTemp);
    }
  };

  const saveLocalPushSettings = async (settingTemp: any) => {
    const storeList = getRecoil<authStoreType[]>(authStoreListState);
    const localPushCheck = AsyncLocalStorage.getItem("localPushCheck");
    const localPushSetting = AsyncLocalStorage.getItem("pushSetting");
    try {
      if (localPushSetting.authPushOrder && !localPushCheck) {
        storeList.map(async (item) => {
          await StoreController.setAutoConfirmed(
            item.store_id,
            localPushSetting.autoPushOrder
          );
        });
        // const pushSetting = {
        //   effect: settingTemp.effect,
        //   volume: settingTemp.volume,
        //   orderCount: settingTemp.orderCount,
        //   infinite: settingTemp.orderCount < 11 ? false : true,
        //   delay: settingTemp.delay,
        // };

        // await AsyncLocalStorage.setItem(
        //   "pushSetting",
        //   JSON.stringify(pushSetting)
        // );
        await AsyncLocalStorage.setItem("localPushCheck", JSON.stringify(true));
        console.log("autoPushOrder transfer!!!!!", pushSetting);
      }
    } catch (err) {
      console.log("err => ", err);
    }
  };

  useEffect(() => {
    getSoundData();
    initializeSounds();
  }, []);

  useEffect(() => {
    if (isVisible) {
      getSoundData();
      initializeSounds();
    }
  }, [isVisible]);

  useEffect(() => {
    getVolumeItems(volume);
  }, [volume]);

  return (
    <Modal
      open={isVisible}
      onClose={onCloseModal}
      center
      classNames={{
        overlay: "pushSettingModalOverlay",
        modal: "pushSettingModal",
      }}
      closeIcon={
        <img
          src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_close.svg`}
          alt="ic"
        />
      }
      showCloseIcon={true}
      animationDuration={150}
    >
      <Style>
        <div className="modal">
          <div className="modalHeader">
            <h3>알림 설정</h3>
          </div>
          <div className="alarmWrap">
            {/* <div className="toggleListWrap">
              <div className="between">
                <h3>자동 주문접수</h3>
                <CustomToggle
                  toggleItem={autoPushOrder}
                  onChange={setAutoPushOrder}
                />
              </div>
              <h5>설정한 준비시간으로 주문이 자동접수됩니다.</h5>
            </div> */}
            <div className="contentWrap">
              <h4>알림음 설정</h4>
              <div className="row">
                {soundList.effectSound.map(
                  (soundFile: string, index: number) => (
                    <button
                      key={index}
                      className={`effectButton ${
                        soundList.effectSound.indexOf(selectedEffect) ===
                          index && "active"
                      }`}
                      onClick={() => {
                        onChange_selectedEffect(soundFile, index);
                      }}
                    >
                      알림음{index + 1}
                    </button>
                  )
                )}
              </div>
            </div>
            <div className="contentWrap">
              <h4>횟수 선택</h4>
              <div className="row">
                <button
                  className={`radio ${isInfinite && "active"}`}
                  onClick={() => {
                    setInfinity(true);
                  }}
                />
                <h5>주문 받을 때 까지</h5>
              </div>
              <div className="row">
                <button
                  className={`radio ${!isInfinite && "active"}`}
                  onClick={() => {
                    setInfinity(false);
                  }}
                />
                <h5>횟수 설정</h5>
                <div className="countButton">
                  <img
                    src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_minus${
                      orderCount < 1 || isInfinite ? "_unabled" : ""
                    }.svg`}
                    onClick={subtractCount}
                    alt="ic"
                  />
                  <p className={`${isInfinite && "inactive"}`}>
                    {isInfinite ? 0 : orderCount}
                  </p>
                  <img
                    src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_plus${
                      orderCount > 9 || isInfinite ? "_unabled" : ""
                    }.svg`}
                    onClick={addCount}
                    alt="ic"
                  />
                </div>
              </div>
            </div>
            <div className="contentWrap">
              <h4>음량</h4>
              <div className="volumeWrap">
                <button
                  className="volumeButton"
                  onClick={() => onChange_volume(volume - 1)}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_minus${
                      volume < 2 ? "_unabled" : ""
                    }.svg`}
                    alt="ic"
                  />
                </button>
                <div className="volumeBar">
                  {volumeItems.map((item: number, index: number) => {
                    return (
                      <div
                        key={index}
                        onClick={() => {
                          onChange_volume(index + 1);
                        }}
                        className={`volumeItem ${item === 1 && "active"}`}
                      />
                    );
                  })}
                </div>
                <button
                  className="volumeButton"
                  onClick={() => onChange_volume(volume + 1)}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_plus${
                      volume > 9 ? "_unabled" : ""
                    }.svg`}
                    alt="ic"
                  />
                </button>
              </div>
            </div>
            <div className="contentWrap">
              <h4>알림 주기</h4>
              <div className="row">
                <div className="countButton delay">
                  <img
                    src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_minus${
                      audioDelay < 2 ? "_unabled" : ""
                    }.svg`}
                    onClick={subtractDelay}
                    alt="ic"
                  />
                  <p>{audioDelay}초</p>
                  <img
                    src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_plus${
                      audioDelay > 9 ? "_unabled" : ""
                    }.svg`}
                    onClick={addDelay}
                    alt="ic"
                  />
                </div>
              </div>
            </div>
          </div>
          <button className="save" onClick={savePushSetting}>
            <h4>저장</h4>
          </button>
        </div>
      </Style>
    </Modal>
  );
};

export default PushSettingModal;

const Style = styled.div`
  .modal {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 4%;
  }

  .row {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;

    h5 {
      color: #000000;
      font-weight: 400;
    }
  }

  .modalHeader {
    padding: 4% 6%;
    width: 100%;
    border-bottom: 1px solid #f0f0f0;
    h3 {
      color: #333333;
      font-size: 20px;
      line-height: 24px;
      font-weight: 600;
      text-align: center;
    }
  }
  .alarmWrap {
    width: 100%;
    height: 100%;
    padding: 6% 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }

  .effectButton {
    padding: 6px 16px;
    border-radius: 5px;
    border: 1px solid #d2d2d2;
    background: #ffffff;
    font-size: 16px;
    line-height: 20px;
    font-weight: 400;
    color: #000000;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .effectButton.active {
    border: 1px solid #000000;
    background: #000000;
    color: #ffffff;
  }

  .volumeWrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    .volumeButton {
      padding: 6px;
      border-radius: 3px;
      border: 1px solid #d2d2d2;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .volumeBar {
      width: 100%;
      display: flex;
      align-items: center;
      height: 16px;
      border-radius: 3px;
      background: #ececec;
      gap: 1px;

      .volumeItem {
        width: calc((100% - 9px) / 10);
        height: 100%;
        border-radius: 3px;
        background: #ececec;
      }
      .volumeItem.active {
        background: #000000;
      }
    }
  }

  .contentWrap {
    padding: 0 6%;
    width: 100%;
    display: flex;
    flex-direction: column;
    text-align: left;
    gap: 6px;

    h4 {
      font-weight: 500;
      color: #333333;
    }
    p {
      font-size: 16px;
      line-height: 20px;
      color: #333333;
      font-weight: 400;
    }
  }

  input[type="checkbox"] {
    display: none;
  }
  label {
    display: flex;
    align-items: flex-start;
    gap: 6px;
    font-size: 14px;
    line-height: 20px;
    font-weight: 400;
    color: #333333;
    word-break: keep-all;
    white-space: pre-line;

    .checkbox {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 20px;
      height: 20px;
      border-radius: 3px;
      background: #ffffff;
      border: 1px solid #d2d2d2;
    }
    .checkbox.active {
      background: #000000;
      border: 1px solid #000000;
    }
  }
  label.inactive {
    color: #999999;
  }

  .countButton {
    border-radius: 3px;
    border: 1px solid #d2d2d2;
    width: 84px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 2px 12px;

    p.inactive {
      color: #ececec;
    }
  }
  .countButton.delay {
    width: 100px;
  }

  .radio {
    padding: 7px;
    border: 1px solid #d2d2d2;
    border-radius: 100px;
  }
  .radio.active {
    padding: 3px;
    border: 5px solid #000000;
  }

  button.save {
    width: 88%;
    padding: 10px 0;
    background-color: #000;
    border-radius: 5px;
    box-shadow: 0px 4px 4px 0px #00000040;
    h4 {
      color: #ffffff;
      font-weight: 600;
    }
  }
`;
